






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { DxAutocomplete, DxRadioGroup, DxLookup } from 'devextreme-vue';
import Card from '@/components/default/Card.vue';
import notificationService from '@/services/notificationService';
import PdfViewer from '@/plugins/pdfjs/PdfViewer.vue';
import CreditNoteMailPopup from '@/modules/creditnotes/components/CreditNoteMailPopup.vue';

import { DxForm, DxSimpleItem, DxLabel, DxItem } from 'devextreme-vue/form';

import { CreditNotesClient, CreditNoteDto, GenerateCreditNoteDocumentCommand } from '@/data/web-api-client';

@Component({
  components: {
    Card,
    DxForm,
    DxSimpleItem,
    DxLabel,
    DxAutocomplete,
    PdfViewer,
    DxRadioGroup,
    DxLookup,
    DxItem,
    CreditNoteMailPopup,
  },
})
export default class CreditNoteDocument extends Vue {
  @Prop({ required: true })
  creditNote!: CreditNoteDto;
  pdfSize: number = 450;
  settings: any = {
    language: null,
    groupArticlesByCategory: false,
  };
  document: {
    loading: boolean;
    initialised: boolean;
    url: string;
  } = {
    loading: false,
    initialised: false,
    url: '',
  };
  languages: string[] = [];
  creditNotesClient = new CreditNotesClient(undefined, this.$axios);

  mounted() {
    this.pdfSize = window.innerHeight - 275;
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];
    this.loadDocument();
  }

  async loadDocument() {
    try {
      this.document.loading = true;
      const result = await this.creditNotesClient.download(this.$route.params.id);

      this.document.url = window.URL.createObjectURL(result.data);
      this.document.initialised = true;
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  async generateDocument() {
    try {
      this.document.loading = true;
      const command = new GenerateCreditNoteDocumentCommand({
        id: this.creditNote.id,
        language: this.settings.language,
        groupArticlesByCategory: this.settings.groupArticlesByCategory,
      });
      const result = await this.creditNotesClient.generateDocument(this.creditNote.id!, command);

      this.document.url = window.URL.createObjectURL(result.data);
    } catch (err) {
      notificationService.showAxiosError(err);
    } finally {
      this.document.loading = false;
    }
  }

  openMailDialog() {
    (this.$refs.MailDialog as CreditNoteMailPopup).open();
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      showClearButton: 'true',
    };
  }
}
